<template>
  <div class="welcome-box">
    <div class="titleBox">
      <p class="nickname">欢迎登陆「{{ userInfo.admin.name }}」</p>
      <p class="title">两年半后台管理系统</p>
    </div>
  </div>
</template>
<script>
import local from "@/utils/localStroage.js";
// import list from '@/router/permissionRouter.js'
export default {
  data() {
    return {};
  },
  computed: {
    userInfo: () => {
      return local.get("userInfo");
    },
  },
};
</script>
<style lang="scss" scoped>
.welcome-box {
  width: 100%;
  height: 100%;
  background: url(../../assets/images/welcome.jpg) no-repeat;
  background-size: cover;
  background-position: center center;
  border-radius: 5px;
  div {
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.95);
    overflow: hidden;
    p {
      width: 100%;
      text-align: center;
      // color: #ff8000;
      font-size: 76px;
    }
    .nickname {
      margin: 150px 0 30px 0;
      font-size: 50px;
      font-weight: 500;
      letter-spacing: 5px;
      filter: blur(0px);
      animation: changeSpcaing 3s;
    }
  }
  .title {
    font-weight: 500;
    letter-spacing: 5px;
    filter: blur(0px);
    animation: changeSpcaing 3s;
  }
}
.titleBox {
  color: rgb(71, 136, 246);
  filter: contrast(200%);
}
@keyframes changeSpcaing {
  0% {
    letter-spacing: -60px;
    filter: blur(5px);
  }
  100% {
    letter-spacing: 5px;
    filter: blur(0px);
  }
}
</style>
